import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TEXTS from "./assets/json/texts.json";
import api from "./Services/api.js";
import { Authenticator, AuthenticatorSec, AuthenticatorCoordenador, AuthenticatorProfessor } from "./auth";

// Components
import Navbar from "./Components/Navbar";
import Globalstyles from "./globalstyles";

// Pages
import Login from "./Pages/Login";
import HomeAluno from "./Pages/HomeAluno";
import HomeSecretaria from "./Pages/HomeSecretaria";
import NaoAutorizado from "./Pages/NaoAutorizado";
import CadastroAluno from "./Pages/CadastroAluno";
import DesativarAluno from "./Pages/DesativarAluno";
import VisualizarAlunos from "./Pages/VisualizarAlunos";
import VerCarterinhas from "./Pages/VerCarterinhas";
import VisualizarUsuarios from "./Pages/VisualizarUsuarios";
import AlunoSemFoto from "./Pages/AlunoSemFoto";
import VerCarterinha from "./Pages/VerCarterinha";
import DadosPublicos from "./Pages/DadosPublicos";
import AvisoManutencao from "./Pages/Manutencao";
import ProfessorHome from "./Pages/HomeProfessor/index.jsx";
import CoordenadorHome from "./Pages/HomeCoordenador/index.jsx";
import { ProgressaoParcialCoordenador } from "./Pages/ProgressaoParcial/Coordenador/index.jsx";
import { ProgressaoParcialProfessor } from "./Pages/ProgressaoParcial/Professor/index.jsx";
import { ProgressaoParcialAluno } from "./Pages/ProgressaoParcial/Aluno/index.jsx";
import PdfCracha from "./Pages/PdfCracha/index.jsx";
import VisualizarProgreSec from "./Pages/VisualizarProgreSec/index.jsx";
import ProgressaoHome from "./Pages/ProgressaoHome/index.jsx";
import { ProgressaoParcialSecretaria } from "./Pages/ProgressaoParcial/Secretaria/index.jsx";
import VisualizarProgreCoord from "./Pages/VisualizarProgreCoord/index.jsx";

// Protected Route Components
const ProtectedRoute = ({ children, requireSec = false, requireProf = false, requireCoord = false }) => {
  const isAuthenticated = requireSec
    ? AuthenticatorSec()
    : requireProf
    ? AuthenticatorProfessor()
    : requireCoord
    ? AuthenticatorCoordenador()
    : Authenticator();

  if (!isAuthenticated) {
    return <NaoAutorizado />;
  }

  return children;
};

const routes = () => {
  const [maintenanceStatus, setMaintenanceStatus] = useState({
    isActive: false,
    timeRemaining: { days: 0, hours: 0, minutes: 0, seconds: 0 },
  });

  const [firstAccess, setFirstAccess] = useState(false);

  useEffect(() => {
    // Check first access
    if (!!localStorage.getItem("Entrada") == true) {
      if (localStorage.getItem("Entrada") == "Informe uma senha para o aluno.") {
        setFirstAccess(true);
      } else {
        setFirstAccess(false);
      }
    }
    // Maintenance timer
    const calculateTimeRemaining = () => {
      const now = new Date();
      const targetDate = new Date(TEXTS.MAINTENANCE_END_DATE);

      if (now >= targetDate) {
        setMaintenanceStatus((prev) => ({ ...prev, isActive: false }));
        return;
      }

      const total = targetDate.getTime() - now.getTime();
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      const hours = Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((total % (1000 * 60)) / 1000);

      setMaintenanceStatus({
        isActive: true,
        timeRemaining: { days, hours, minutes, seconds },
      });
    };

    calculateTimeRemaining();
    const timer = setInterval(calculateTimeRemaining, 1000);
    return () => clearInterval(timer);
  }, []);

  if (maintenanceStatus.isActive) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<AvisoManutencao timeRemaining={maintenanceStatus.timeRemaining} />} />
        </Routes>
        <Globalstyles />
      </BrowserRouter>
    );
  }

  // const [timeInterval, setTimeInterval] = useState(100000); // Inicia com 100s
  // const [detectVPN, setDetectVPN] = useState({ acess: true });
  // const [mouseTimeout, setMouseTimeout] = useState(null); // Armazena o timeout

  // useEffect(() => {
  //   const handleMouseMove = () => {
  //     setTimeInterval(10000); // Reduz o tempo para 10s após o movimento do mouse

  //     // Se já existir um timeout, cancela antes de criar um novo
  //     if (mouseTimeout) {
  //       clearTimeout(mouseTimeout);
  //     }

  //     // Cria um timeout que aumenta o tempo para 1 minuto após 10s sem movimento
  //     const newTimeout = setTimeout(() => {
  //       setTimeInterval(60000); // Após 10s sem movimento, define para 1 minuto
  //     }, 10000); // 10s sem movimento

  //     setMouseTimeout(newTimeout);
  //   };

  //   window.addEventListener("mousemove", handleMouseMove);

  //   return () => {
  //     window.removeEventListener("mousemove", handleMouseMove);
  //     if (mouseTimeout) {
  //       clearTimeout(mouseTimeout);
  //     }
  //   };
  // }, [mouseTimeout]);

  // useEffect(() => {
  //   const verificarVPN = async () => {
  //     try {
  //       const response = await fetch("https://ipinfo.io/json?token=29c8818f1c5ea7");
  //       const ipCheck = await response.json();
  //       console.log(ipCheck);

  //       if (ipCheck.country !== "BR") {
  //         return setDetectVPN({ erro: `Não disponível em seu país!`, acess: false });
  //       }

  //       return setDetectVPN({ acess: true });
  //     } catch (error) {
  //       console.error("❌ Erro ao verificar VPN:", error);
  //       return setDetectVPN({ acess: false });
  //     }
  //   };

  //   verificarVPN(); // Primeira verificação
  //   const interval = setInterval(verificarVPN, timeInterval);

  //   return () => clearInterval(interval); // Limpa o intervalo ao desmontar ou mudar `timeInterval`
  // }, [timeInterval]);

  // if (!detectVPN.acess) {
  //   return (
  //     <BrowserRouter>
  //       <Routes>
  //         <Route path="*" element={<AvisoManutencao text={detectVPN.erro || "acesso negado!"} />} />
  //       </Routes>
  //       <Globalstyles />
  //     </BrowserRouter>
  //   );
  // }

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        {/* Rotas Públicas */}
        <Route path="/" element={<Login />} />
        <Route path="/v/:id" element={<DadosPublicos />} />

        {/* Rota de ajuda externa */}
        <Route path="/Ajuda" element={<Navigate to="https://alunos.tawk.help" replace />} />

        {/* Rotas estudantis protegidas */}
        <Route
          path="/aluno"
          element={
            <ProtectedRoute>
              <HomeAluno first={firstAccess} />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/progressao-parcial"}
          element={
            <ProtectedRoute>
              <ProgressaoParcialAluno />
            </ProtectedRoute>
          }
        />

        {/* Rotas da Secretaria protegidas */}
        <Route
          path="/secretaria"
          element={
            <ProtectedRoute requireSec>
              <HomeSecretaria />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vercarterinhasecretaria"
          element={
            <ProtectedRoute requireSec>
              <VerCarterinha />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cadastroaluno"
          element={
            <ProtectedRoute requireSec>
              <CadastroAluno />
            </ProtectedRoute>
          }
        />
        <Route
          path="/desativaraluno"
          element={
            <ProtectedRoute requireSec>
              <DesativarAluno />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vercarterinhas"
          element={
            <ProtectedRoute requireSec>
              <VerCarterinhas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/visualizaralunos"
          element={
            <ProtectedRoute requireSec>
              <VisualizarAlunos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/visualizarprogre"
          element={
            <ProtectedRoute requireSec>
              <VisualizarProgreSec />
            </ProtectedRoute>
          }
        />
        <Route
          path="/visualizarprogre/coordenador"
          element={
            <ProtectedRoute requireCoord>
              <VisualizarProgreCoord />
            </ProtectedRoute>
          }
        />
        <Route
          path="/visualizarusuarios"
          element={
            <ProtectedRoute requireCoord>
              <VisualizarUsuarios />
            </ProtectedRoute>
          }
        />
        <Route
          path="/alunosemfoto"
          element={
            <ProtectedRoute requireSec>
              <AlunoSemFoto />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gerar-cracha/pdf-turma"
          element={
            <ProtectedRoute requireSec>
              <PdfCracha />
            </ProtectedRoute>
          }
        />

        <Route
          path="/home-progressao"
          element={
            <ProtectedRoute requireSec>
              <ProgressaoHome />
            </ProtectedRoute>
          }
        />
         <Route
          path="/home-progressao-coord"
          element={
            <ProtectedRoute requireCoord>
              <ProgressaoHome />
            </ProtectedRoute>
          }
        />

        {/* Rotas do Coordenador protegidas */}
        <Route
          path={"/coordenador"}
          element={
            <ProtectedRoute requireCoord>
              <CoordenadorHome />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/progressao-parcial-coordenador"}
          element={
            <ProtectedRoute requireCoord>
              <ProgressaoParcialCoordenador />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/progressao-parcial-secretaria"}
          element={
            <ProtectedRoute requireSec>
              <ProgressaoParcialSecretaria />
            </ProtectedRoute>
          }
        />

        {/* Rotas do Professor protegidas */}
        <Route
          path={"/professor"}
          element={
            <ProtectedRoute requireProf>
              <ProfessorHome />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/progressao-parcial-professor"}
          element={
            <ProtectedRoute requireProf>
              <ProgressaoParcialProfessor />
            </ProtectedRoute>
          }
        />

        {/* Pegue todas as rotas incomparáveis */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Globalstyles />
    </BrowserRouter>
  );
};

export default routes;
